export default "__VITE_ASSET__EC4_I$Gg__"